import React from 'react';

type ScribaneMarkProps = {
  className?: string;
};

export const ScribaneMark: React.FC<ScribaneMarkProps> = ({ className }) => (
  <svg
    viewBox="160 100 130 265"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M231.37,108v106.36c0,3.01,1.78,5.73,4.53,6.94,10.43,4.58,17.47,15.49,16.16,27.86-1.33,12.51-11.43,22.69-23.94,24.09-16.4,1.84-30.35-11.01-30.35-27.05,0-11.1,6.69-20.65,16.24-24.88,2.78-1.23,4.61-3.93,4.61-6.97v-106.35s-61.12,123.87-61.12,123.87c-5.23,10.59-6.22,22.78-2.77,34.08l21.2,69.51c1.18,3.88,4.77,6.53,8.82,6.53h0c5.09,0,9.22-4.13,9.22-9.22v-30.77c0-10.22,8.28-18.5,18.5-18.5h25.02c10.22,0,18.5,8.28,18.5,18.5v30.77c0,5.09,4.13,9.22,9.22,9.22h0c4.06,0,7.64-2.65,8.82-6.53l21.2-69.5c3.45-11.3,2.46-23.49-2.77-34.08l-61.12-123.87Z"
      fill="currentColor"
    />
  </svg>
);
